var map = {
	"./Email.png": "ed48",
	"./Facebook.png": "32b7",
	"./Instagram.png": "a6e1",
	"./Linkedin.png": "8174",
	"./Site.png": "1e6b",
	"./Telefone.png": "e406",
	"./Telegram.png": "69be",
	"./Twitter.png": "71aa",
	"./Whatsapp.png": "3111",
	"./YouTube.png": "0adc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";